import { useState, useCallback } from 'react'

const API_BASE = import.meta.env.VITE_API_BASE || 'https://agx9-ndvi-v2.sv9.workers.dev'

export async function api(path, opts = {}) {
  const url = `${API_BASE}${path}`
  const res = await fetch(url, {
    ...opts,
    headers: {
      'Accept': 'application/json',
      ...(opts.headers || {}),
    },
  })
  if (!res.ok) throw new Error(`HTTP ${res.status}`)
  return res.json()
}

export function useApi() {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  const request = useCallback(async (path, opts) => {
    setLoading(true)
    setError(null)
    try {
      const data = await api(path, opts)
      return data
    } catch (e) {
      setError(e.message)
      throw e
    } finally {
      setLoading(false)
    }
  }, [])

  return { request, loading, error, setError }
}
